/* eslint-disable jsx-control-statements/jsx-use-if-tag */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable no-magic-numbers */
/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Icon } from '../../atoms'

const Carousel = ({ children }) => {
  let classCard = 'GuideCardCarousel__Card tgCards'
  if (children.length > 3) {
    classCard = 'GuideCardCarousel__Card fgCards'
  }
  return (
    <section className='GuideCardCarousel' data-controller='platinum-carousel'>
      <div className='GuideCardCarousel__Container'>
        <div className='GuideCardCarousel__Cards' data-platinum-carousel-target='carouselContainer'>
          {children.map((child, index) => {
            return (
              <div
                key={index}
                className={`${classCard}`}
                data-platinum-carousel-target='carouselCard'
                /* eslint-disable camelcase */
              >
                <div>
                  <div className='GuideCardCarousel__Card__body'>{child}</div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <div className='GuideCardCarousel__arrows'>
        {children.length > 3 && (
          <div
            id='GuideCardCarousel__leftArrow'
            className='GuideCardCarousel__leftArrow'
            data-action='leftArrowIconClick'
          >
            <Icon glyph={'ButtonLeftDisabled'} size={40} desktopSize={40} />
          </div>
        )}
        {children.length > 3 && (
          <div
            id='GuideCardCarousel__rightArrow'
            className='GuideCardCarousel__rightArrow'
            data-action='rightArrowIconClick'
          >
            <Icon glyph={'arrow-right'} size={40} desktopSize={40} />
          </div>
        )}
      </div>
    </section>
  )
}

export default Carousel
